import { render, staticRenderFns } from "./integralShop.vue?vue&type=template&id=4b6d07e5&scoped=true"
import script from "./integralShop.vue?vue&type=script&lang=js"
export * from "./integralShop.vue?vue&type=script&lang=js"
import style0 from "./integralShop.vue?vue&type=style&index=0&id=4b6d07e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6d07e5",
  null
  
)

export default component.exports